/* FuJo × Uploadery — show selected filename on styled pill. Safe with required upload. */
(function () {
  function bind(root) {
    var inputs = (root || document).querySelectorAll(
      "#uploadery-container .spb-fileupload input[type='file'], .uploadery-auto-insert .spb-fileupload input[type='file']"
    );
    for (var i = 0; i < inputs.length; i++) {
      (function (input) {
        if (input.getAttribute("data-fujo-bound") === "1") return;
        input.setAttribute("data-fujo-bound", "1");
        var wrap = input.closest(".spb-fileupload");
        if (!wrap) return;
        function sync() {
          var file = input.files && input.files[0];
          if (file && file.name) {
            wrap.classList.add("has-file");
            wrap.setAttribute("data-filename", file.name);
          } else {
            wrap.classList.remove("has-file");
            wrap.removeAttribute("data-filename");
          }
        }
        input.addEventListener("change", sync);
        sync();
      })(inputs[i]);
    }
  }

  function start() {
    bind(document);
    if (typeof MutationObserver === "undefined") return;
    var mo = new MutationObserver(function () {
      bind(document);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
